import type { Translation } from '../i18n-types';

const de: Translation = {
  userGuide: 'Benutzerhandbuch',
  privacyPolicy: 'Datenschutz-Bestimmungen',
  termsConditions: 'Geschäftsbedingungen',
  support: 'Support',
  abandoned: 'Verlassen',
  completed: 'Abgeschlossen',
  cancelled: 'Abgebrochen',
  ended: 'Beendet',
  actionComments: 'Aktionskommentare',
  actionItem: 'Action Item',
  actionItemPlaceholder: 'Action Item...',
  actionItems: 'Action Items',
  actionPhaseDescription: 'Fügen Sie Action Items hinzu, Sie können keine Kommentare mehr gruppieren oder abstimmen',
  actions: 'Aktionen',
  activate: 'Aktivieren',
  active: 'Aktiv',
  activeRetros: 'Aktive Retros',
  activeRetroUsers: 'Aktive Retro Benutzer',
  activeStoryboards: 'Aktive Storyboards',
  activeStoryboardUsers: 'Aktive Storyboard Benutzer',
  addComment: 'Kommentar hinzufügen',
  addPersona: 'Persona hinzufügen',
  admin: 'Verwaltung',
  adminCleanOldRetros: 'Retros löschen, die älter als {daysOld} Tage sind',
  adminCleanOldStoryboards: 'Storyboards löschen, die älter als {daysOld} Tage sind',
  adminPageAdmin: 'Allgemein',
  adminPageAlerts: 'Benachrichtigungen',
  adminPageApi: 'API-Schlüssel',
  adminPageOrganizations: 'Organisationen',
  adminPageTeams: 'Teams',
  adminPageUsers: 'Benutzer',
  adminPageSubscriptions: 'Abonnements',
  deleteSubscriptionConfirmation: 'Sind Sie sicher, dass Sie dieses Abonnement löschen möchten?',
  deleteSubscription: 'Abonnement löschen',
  alertAllowDismiss: 'Ablehnen erlauben',
  alertContent: 'Inhalt der Benachrichtigung',
  alertContentPlaceholder: 'Inhalt der Benachrichtigung eingeben',
  alertCreate: 'Benachrichtigung erstellen',
  alertDelete: 'Benachrichtigung löschen',
  alertDeleteConfirmation: 'Möchten Sie diese Benachrichtigung wirklich löschen?',
  alertNamePlaceholder: 'Name für die Benachrichtigung eingeben',
  alertRegisteredOnly: 'Nur für registrierte Benutzer',
  alerts: 'Benachrichtigungen',
  alertSave: 'Benachrichtigung speichern',
  alertTypePlaceholder: 'Art der Benachrichtigung auswählen',
  allVotesIn: 'Alle Stimmen abgegeben',
  apiDocumentation: 'API-Dokumentation',
  apikeyCopyFailure: 'API-Schlüssel konnte nicht in die Zwischenablage kopiert werden',
  apikeyCopySuccess: 'API-Schlüssel wurde in die Zwischenablage kopiert',
  apiKeys: 'API-Schlüssel',
  applicationStatsError: 'Fehler beim Abrufen der Anwendungsstatistiken',
  appName: 'Thunderdome',
  appPreviewAlt: 'Vorschau von Thunderdome, Agile Planning Poker UI Experience',
  appSubtitle: 'Open Source Agile Planning Poker App',
  appVersion: 'version {version}',
  associateTeam: 'Team verknüpfen',
  authError: 'Beim Versuch, den Benutzer zu authentifizieren, ist ein Fehler aufgetreten',
  autoFinishVoting: 'Automatisches Beenden der Abstimmung',
  avatarAltText: 'Avatar Platzhalter',
  back: 'Zurück',
  battleAbandon: 'Partie verlassen',
  battleCreate: 'Partie erstellen',
  battleDelete: 'Partie löschen',
  battleEdit: 'Partie bearbeiten',
  battleEditPointsDisabled: 'Schätzung ist aktiv, zulässige Punkte können nicht geändert werden.',
  battleJoin: 'Partie beitreten',
  battleName: 'Name der Partie',
  battleRemoveError: 'Fehler beim Entfernen der Partie aufgetreten.',
  battleRemoveSuccess: 'Partie erfolgreich entfernt.',
  battles: 'Partien',
  battlesActive: 'Aktive Partien',
  battlesActiveUsers: 'Aktive Benutzer in der Partie',
  becomeFacilitator: 'Moderator werden',
  becomeParticipant: 'Teilnehmer werden',
  becomeSpectator: 'Zuschauer werden',
  blocked: 'Blockiert',
  blockers: 'Blockierer',
  blockersPlaceholder: 'Ich werde blockiert von...',
  brainstorm: 'Brainstorming',
  brainstormPhaseDescription: 'Fügen Sie Ihre Kommentare unten hinzu',
  brainstormPhaseFeedbackVisibility: 'Sichtbarkeit des Feedbacks in der Brainstorming-Phase',
  brainstormVisibilityLabelConcealed: 'Feedback versteckt',
  brainstormVisibilityLabelHidden: 'Feedback ausgeblendet',
  brainstormVisibilityLabelVisible: 'Feedback sichtbar',
  cancel: 'Abbrechen',
  cannotBeUndone: 'Das kann nicht rückgängig gemacht werden.',
  checkIn: 'Einchecken',
  checkinCommentDeleteError: 'Fehler beim Löschen des Eincheck-Kommentars',
  checkinCommentError: 'Fehler beim Kommentieren des Eincheckens',
  checkinError: 'Fehler beim Einchecken',
  checkinMeetYesterdayGoalsQuestion: 'Haben Sie die gestrigen Ziele erreicht?',
  checkins: 'Einchecken',
  colorLegend: 'Farblegende',
  colorLegendNotSpecified: 'Legende nicht angegeben',
  comment: 'Kommentar',
  comments: 'Kommentare',
  conciseVotingResults: 'Kurze Abstimmungsergebnisse',
  confirmDeleteRetro: 'Sind Sie sicher, dass Sie diese Retrospektive löschen möchten?',
  createAccount: 'Konto erstellen',
  createAccountTagline: 'Haben Sie noch kein Konto?',
  createAlertError: 'Fehler beim Erstellen der Benachrichtigung',
  createAlertSuccess: 'Benachrichtigung erfolgreich erstellt',
  createARetro: 'Erstellen Sie eine Retro',
  createAStoryboard: 'Erstellen Sie ein Storyboard',
  createBattleError: 'Fehler beim Erstellen einer Partie',
  createOrgError: 'Fehler beim Versuch, eine Organisation zu erstellen',
  createRetro: 'Retro erstellen',
  createRetroErrorMessage: 'Fehler beim Erstellen der Retro',
  createStoryboard: 'Storyboard erstellen',
  createUserError: 'Fehler beim Erstellen des Benutzers',
  customizableBattleOptions: 'Anpassbare Partieoptionen',
  dateCreated: 'Erstellungsdatum',
  dateUpdated: 'Aktualisierungsdatum',
  delete: 'Löschen',
  deleteActionItemError: 'Fehler beim Löschen des Action Items',
  deleteActionItemSuccess: 'Action Item erfolgreich gelöscht',
  deleteAlertError: 'Fehler beim Versuch, die Benachrichtigung zu löschen',
  deleteAlertSuccess: 'Benachrichtigung erfolgreich gelöscht',
  deleteBattle: 'Partie löschen',
  deleteBattleConfirmText: 'Sind Sie sicher, dass Sie diese Partie löschen möchten?',
  deleteBattleError: 'Fehler beim Löschen der Partie',
  deleteCheckinError: 'Fehler beim Löschen des Check-ins',
  deleteDepartment: 'Abteilung löschen',
  deleteDepartmentConfirmText: 'Sind Sie sicher, dass Sie diese Abteilung löschen möchten?',
  deleteOrganization: 'Organisation löschen',
  deleteOrganizationConfirmText: 'Sind Sie sicher, dass Sie diese Organisation löschen möchten?',
  deleteRetro: 'Retro löschen',
  deleteRetroErrorMessage: 'Fehler beim Löschen der Retro',
  deleteStoryboard: 'Storyboard löschen',
  deleteStoryboardErrorMessage: 'Fehler beim Löschen des Storyboards',
  deleteTeam: 'Team löschen',
  deleteTeamConfirmText: 'Sind Sie sicher, dass Sie dieses Team löschen möchten?',
  deleteUserError: 'Fehler beim Löschen des Benutzers',
  demote: 'Degradieren',
  demoteUserError: 'Fehler beim Degradieren des Benutzers',
  department: 'Abteilung',
  departmentCreate: 'Abteilung erstellen',
  departmentCreateError: 'Fehler beim Erstellen der Abteilung',
  departmentDeleteError: 'Fehler beim Versuch, die Abteilung zu löschen',
  departmentDeleteSuccess: 'Abteilung erfolgreich gelöscht',
  departmentGetError: 'Fehler beim Abrufen der Abteilung',
  departmentName: 'Abteilungsname',
  departmentNamePlaceholder: 'Abteilungsname eingeben',
  departments: 'Abteilungen',
  departmentSave: 'Abteilung speichern',
  departmentTeamsGetError: 'Fehler beim Abrufen der Abteilungsteams',
  departmentUsersGetError: 'Fehler beim Abrufen der Abteilungsbenutzer',
  discuss: 'Diskutieren',
  discussPlaceholder: 'Ich möchte diskutieren...',
  done: 'Erledigt',
  duplicateRetroSession: 'Doppelte Retro-Sitzung existiert für Ihre ID',
  duplicateStoryboardSession: 'Doppelte Storyboard-Sitzung existiert für Ihre ID',
  edit: 'Bearbeiten',
  editColorLegend: 'Legende bearbeiten',
  editRetro: 'Retro bearbeiten',
  editStoryboard: 'Storyboard bearbeiten',
  email: 'E-Mail',
  enterPasscode: 'Passcode eingeben...',
  enterYourEmail: 'Geben Sie Ihre E-Mail ein',
  execute: 'Ausführen',
  export: 'Exportieren',
  facilitator: 'Moderator',
  facilitatorCode: 'Moderator Code',
  facilitatorCodeOptional: 'Moderator Code (Optional)',
  facilitatorCodePlaceholder: 'Geben Sie einen optionalen Moderator Code ein',
  finalPoints: 'Endpunkte',
  flag: 'Flagge',
  footerAuthoredBy: 'Erstellt mit ❤️ von {authorOpen}Steven Weathers{authorClose}',
  forgotPassword: 'Passwort vergessen?',
  forgotPasswordSubtext: `Keine Sorge! Geben Sie einfach Ihre E-Mail ein und wir senden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts.`,
  returnToLogin: 'Zurück zum Login',
  getAlertsError: 'Fehler beim Abrufen der Benachrichtigungen',
  getApikeysError: 'Fehler beim Abrufen der API-Schlüssel',
  getBattleError: 'Fehler beim Abrufen der Partie',
  getBattlesError: 'Fehler beim Abrufen der Partien',
  getCheckinsError: 'Fehler beim Abrufen der Check-ins',
  getOrganizationsError: 'Fehler beim Abrufen der Organisationen',
  getRetroErrorMessage: 'Fehler beim Abrufen der Retro',
  getRetrosErrorMessage: 'Fehler beim Abrufen der Retros',
  getStoryboardErrorMessage: 'Fehler beim Abrufen des Storyboards',
  getStoryboardsErrorMessage: 'Fehler beim Abrufen der Storyboards',
  getTeamsError: 'Fehler beim Abrufen der Teams',
  getUserError: 'Fehler beim Abrufen des Benutzers',
  getUsersError: 'Fehler beim Abrufen der Benutzer',
  goalsMet: 'Ziele erreicht',
  group: 'Gruppe',
  groupName: 'Gruppenname',
  groupPhaseDescription: 'Ziehen Sie Kommentare per Drag & Drop, um sie zu gruppieren',
  hostedDesc: '{linkOpen}Thunderdome.dev{linkClose} ist ein kostenloser gehosteter Dienst (SaaS) ohne Werbung.',
  hostedOrSelfHosted: 'Gehosteter Dienst oder selbst gehostet',
  importCsv: 'Stories aus einer CSV-Datei importieren',
  importCsvFileBadFileTypeError: 'Fehler: falscher Dateityp',
  importCsvFileReadFileError: 'Fehler beim Lesen der Datei',
  importJiraXML: 'Stories aus Jira XML importieren',
  importJiraXMLBadFileTypeError: 'Fehler: falscher Dateityp',
  importJiraXMLReadFileError: 'Fehler beim Lesen der Datei',
  incorrectPassCode: 'Falscher Passcode',
  inviteLinkCopyFailure: 'Einladungslink konnte nicht in die Zwischenablage kopiert werden',
  inviteLinkCopySuccess: 'Einladungslink in die Zwischenablage kopiert',
  jiraXmlImport: 'Jira XML Import',
  joinCodeCopyFailure: 'Passcode konnte nicht in die Zwischenablage kopiert werden',
  joinCodeCopySuccess: 'Passcode in die Zwischenablage kopiert',
  joinCodeLabelOptional: 'Beitrittscode (Optional)',
  joinCodePlaceholder: 'Geben Sie einen optionalen Beitrittscode ein',
  joinRetro: 'Retro beitreten',
  joinStoryboard: 'Storyboard beitreten',
  joinStoryboardError: 'Fehler beim Beitritt zum Storyboard, aktualisieren Sie die Seite und versuchen Sie es erneut.',
  landingCountries: 'Benutzer in über {count} Ländern',
  landingFeatureOpenSourceText:
    'Schauen Sie sich das {repoOpen}Github Repository{repoClose} an, um Verbesserungen, Übersetzungen und Fehlerbehebungen anzufordern oder beizutragen, oder um zu {donateOpen}Spenden{donateClose}.',
  landingFeatureOpenSourceTitle: 'Open Source',
  landingSalesPitch:
    'Remote-Team-Zusammenarbeit mit agiler Story-Punktbewertung, Sprint-Retrospektive, Story-Mapping und asynchronem Team-Check-In.',
  landingTitle: 'Thunderdome ist eine Agile Planning Poker App',
  lastActive: 'Zuletzt aktiv',
  leaveRetro: 'Retro verlassen',
  leaveStoryboard: 'Storyboard verlassen',
  legendRetroPlaceholder: 'Geben Sie eine Farblegende ein',
  loadingRetro: 'Retro wird geladen...',
  loadingStoryboard: 'Storyboard wird geladen...',
  login: 'Anmelden',
  loginWithSSO: 'Anmelden mit {provider}',
  loginForRetro: 'oder {loginOpen}Anmelden{loginClose} um der Retro beizutreten',
  loginForStoryboard: 'oder {loginOpen}Anmelden{loginClose} um dem Storyboard beizutreten',
  logout: 'Abmelden',
  logoutError: 'Fehler beim Abmelden des Benutzers',
  makeFacilitator: 'Moderator ernennen',
  mfa2faLabel: '2FA/MFA Auth',
  mfa2faRemove: '2FA/MFA entfernen',
  mfa2faRemoveFailure: 'Fehler beim Entfernen von 2FA/MFA',
  mfa2faRemoveSuccess: '2FA/MFA erfolgreich entfernt',
  mfa2faRemoveText: 'Sind Sie sicher, dass Sie 2FA/MFA entfernen möchten?',
  mfa2faSetup: '2FA/MFA einrichten',
  mfaAuthError: 'Fehler bei der Validierung des Authentifikator-Tokens',
  mfaConfirmToken: 'Token bestätigen',
  mfaGenerateFailed: 'Fehler beim Starten der 2FA/MFA-Einrichtung',
  mfaSecretKeyLabel: 'Geheimer Schlüssel',
  mfaSetupFailed: 'Fehler bei der Validierung des 2FA/MFA-Einrichtungstokens',
  mfaSetupIntro:
    'Scannen Sie den folgenden QR-Code mit einer Authentifikator-Anwendung (wie Google Authenticator oder Authy) und geben Sie das generierte Token ein.',
  mfaSetupSuccess: '2FA/MFA erfolgreich aktiviert',
  mfaTokenLabel: 'Authentifikator-Token',
  mfaTokenPlaceholder: 'Token aus Authentifikator-App eingeben',
  myRetros: 'Meine Retros',
  myStoryboards: 'Meine Storyboards',
  name: 'Name',
  needsImprovement: 'Verbesserungsbedarf',
  nextPhase: 'Nächste Phase',
  noComments: 'Keine Kommentare...',
  oldBattleCleanError: 'Fehler beim Bereinigen von Partien',
  oldGuestsCleanError: 'Fehler beim Bereinigen von Gästen',
  oldRetrosCleanError: 'Fehler beim Bereinigen von Retros',
  oldStoryboardsCleanError: 'Fehler beim Bereinigen von Storyboards',
  openSource: 'Open Source',
  optional: '(Optional)',
  optionalLeadercodePlaceholder: 'Optionaler Anführercode, um Anführer zu werden',
  optionalPasscodePlaceholder: 'Optionaler Passcode zum Beitreten',
  organization: 'Organisation',
  organizationCreate: 'Organisation erstellen',
  organizationDeleteError: 'Fehler beim Versuch, die Organisation zu löschen',
  organizationDeleteSuccess: 'Organisation erfolgreich gelöscht.',
  organizationGetDepartmentsError: 'Fehler beim Abrufen der Abteilungen der Organisation',
  organizationGetError: 'Fehler beim Abrufen der Organisation',
  organizationGetTeamsError: 'Fehler beim Abrufen der Teams der Organisation',
  organizationGetUsersError: 'Fehler beim Abrufen der Benutzer der Organisation',
  organizationName: 'Organisationsname',
  organizationNamePlaceholder: 'Organisationsname eingeben',
  organizations: 'Organisationen',
  organizationsAndTeams: 'Organisationen und Teams',
  organizationSave: 'Organisation speichern',
  owner: 'Besitzer',
  participation: 'Teilnahme',
  passCode: 'Passcode',
  passCodeRequired: 'Passcode zum Beitreten erforderlich',
  personas: 'Personas',
  planAcceptanceCriteria: 'Akzeptanzkriterien',
  planAcceptanceCriteriaPlaceholder: 'Akzeptanzkriterien eingeben',
  planAdd: 'Stories hinzufügen',
  planDescription: 'Beschreibung',
  planDescriptionPlaceholder: 'Beschreibung eingeben',
  planLink: 'Link',
  planLinkInvalid: 'Der Link ist keine gültige absolute URL, beinhaltet z.B. das Protokoll (HTTP/HTTPS)',
  planLinkPlaceholder: 'Link zur Story eingeben',
  planName: 'Story Name',
  planNamePlaceholder: 'Story-Name eingeben',
  planPriority: 'Priorität',
  planPriorityBlocker: 'Blocker',
  planPriorityHigh: 'Hoch',
  planPriorityHighest: 'Höchste',
  planPriorityLow: 'Niedrig',
  planPriorityLowest: 'Niedrigste',
  planPriorityMedium: 'Mittel',
  planPriorityPlaceholder: 'Wählen Sie eine Priorität',
  planReferenceId: 'Referenz ID',
  planReferenceIdPlaceholder: 'Referenz ID eingeben',
  plans: 'Stories',
  planSkip: 'Story überspringen',
  planType: 'Story Typ',
  planTypeBug: 'Bug',
  planTypeEpic: 'Epic',
  planTypePlaceholder: 'Typ auswählen',
  planTypeSpike: 'Spike',
  planTypeStory: 'Story',
  planTypeSubtask: 'Subtask',
  planTypeTask: 'Task',
  pointAverageRounding: 'Mittelwert Rundung der Punkte',
  pointed: 'Geschätzt ({count})',
  points: 'Punkte',
  pointValuesAllowed: 'Zulässige Schätzwerte',
  postComment: 'Kommentar posten',
  primeDirective: 'Hauptdirektive',
  promote: 'Befördern',
  promoteUserError: 'Fehler beim Befördern des Benutzers',
  questions: 'Fragen',
  register: 'Registrieren',
  reloadingRetro: 'Ups, Retro wird neu geladen...',
  reloadingStoryboard: 'Ups, Storyboard wird neu geladen...',
  remove: 'Entfernen',
  removeBattle: 'Partie entfernen',
  removeBattleConfirmText: 'Sind Sie sicher, dass Sie diese Partie entfernen möchten?',
  removeRetro: 'Retro entfernen',
  removeRetroConfirmText: 'Sind Sie sicher, dass Sie dieses Retro entfernen möchten?',
  removeStoryboard: 'Storyboard entfernen',
  removeStoryboardConfirmText: 'Sind Sie sicher, dass Sie dieses Storyboard entfernen möchten?',
  removeUser: 'Benutzer entfernen',
  removeUserConfirmText: 'Sind Sie sicher, dass Sie diesen Benutzer entfernen möchten?',
  requestVerifyEmail: 'Bestätigungs-E-Mail anfordern',
  requestVerifyEmailFailure: 'Fehler beim Versuch, eine Bestätigungs-E-Mail zu senden',
  requestVerifyEmailSuccess: 'Bestätigungs-E-Mail angefordert, überprüfen Sie Ihren Posteingang',
  retro: 'Retro',
  retroActionCommentAddError: 'Fehler beim Hinzufügen eines Retro-Aktionskommentars',
  retroActionCommentDeleteError: 'Fehler beim Löschen eines Retro-Aktionskommentars',
  retroActionCommentEditError: 'Fehler beim Bearbeiten eines Retro-Aktionskommentars',
  retroActionItems: 'Retro Action Items',
  retroAddError: 'Fehler beim Versuch, ein Retro hinzuzufügen.',
  retroAddSuccess: 'Retro erfolgreich hinzugefügt.',
  retroDeleted: 'Retro gelöscht',
  retroFeedbackConcealed: 'Feedback versteckt',
  retroFeedbackHidden: 'Feedback ausgeblendet',
  retroImprovePlaceholder: 'Was verbessert werden muss...',
  retroItems: 'Retro Punkte',
  retroJoinError: 'Fehler beim Beitreten zum Retro, aktualisieren und erneut versuchen.',
  retroMaxVotesPerUserLabel: 'Maximale Gruppenstimmen (pro Benutzer)',
  retroName: 'Retro Name',
  retroNamePlaceholder: 'Geben Sie einen Retro-Namen ein',
  retroQuestionPlaceholder: 'Ich möchte fragen...',
  retroRemoveError: 'Fehler beim Versuch, ein Retro zu entfernen.',
  retroRemoveSuccess: 'Retro erfolgreich entfernt.',
  retros: 'Retros',
  retroWorkedPlaceholder: 'Was gut funktioniert hat...',
  role: 'Rolle',
  rolePlaceholder: 'Benutzerrolle auswählen',
  save: 'Speichern',
  search: 'Suche',
  searchLengthError: 'Suchwert muss mindestens 3 Zeichen lang sein',
  selectTeam: 'Wählen Sie ein Team',
  selfHostedDesc: 'Alternativ können Sie es {linkOpen}auf Ihrem eigenen Server ausführen{linkClose}.',
  sessionDuplicate: 'Es existiert bereits eine Partie-Sitzung für Ihre ID',
  showActiveBattles: 'Aktive Partien anzeigen',
  showActiveRetros: 'Aktive Retros anzeigen',
  showActiveStoryboards: 'Aktive Storyboards anzeigen',
  showBlockedCheckins: 'Nur Checkins anzeigen, die eine Diskussion erfordern',
  showCompletedActionItems: 'Abgeschlossene Action Items anzeigen',
  showVoters: 'Schätzer anzeigen',
  skipped: 'Übersprungen',
  spectator: 'Zuschauer',
  storyboard: 'Storyboard',
  storyboardAddColumn: 'Spalte hinzufügen',
  storyboardAddError: 'Fehler beim Versuch, ein Storyboard hinzuzufügen.',
  storyboardAddGoal: 'Ziel hinzufügen',
  storyboardAddStoryToColumn: 'Story zur Spalte hinzufügen',
  storyboardAddSuccess: 'Storyboard erfolgreich hinzugefügt.',
  storyboardColumns: 'Storyboard-Spalten',
  storyboardDeleted: 'Storyboard gelöscht',
  storyboardEditColumn: 'Spalte bearbeiten',
  storyboardGoalName: 'Zielname',
  storyboardGoalNamePlaceholder: 'Geben Sie einen Zielnamen ein',
  storyboardGoals: 'Storyboard-Ziele',
  storyboardPersonas: 'Storyboard-Personas',
  storyboardRemoveError: 'Fehler beim Versuch, ein Storyboard zu entfernen.',
  storyboardRemoveSuccess: 'Storyboard erfolgreich entfernt.',
  storyboards: 'Storyboards',
  storyboardStories: 'Storyboard-Stories',
  columnPersonasTitle: 'Column Personas',
  columnPersonasEmpty: 'Keine Personas zur Spalte hinzugefügt',
  availablePersonas: 'Verfügbare Personas',
  availablePersonasEmpty: 'Keine Personas verfügbar',
  allPersonasAdded: 'Alle Personas wurden zu dieser Spalte hinzugefügt',
  team: 'Team',
  teamCheckins: 'Team Checkins',
  teamCreate: 'Team erstellen',
  teamCreateError: 'Fehler beim Erstellen des Teams.',
  teamCreateSuccess: 'Team erfolgreich angelegt.',
  teamDeleteError: 'Fehler beim Löschen des Teams',
  teamDeleteSuccess: 'Team erfolgreich gelöscht',
  teamGetBattlesError: 'Fehler beim Ermitteln der Partien des Teams',
  teamGetError: 'Fehler beim Ermitteln des Teams',
  teamGetRetroActionsError: 'Fehler beim Abrufen der Retro-Aktionen',
  teamGetRetrosError: 'Fehler beim Abrufen der Team-Retros',
  teamGetStoryboardsError: 'Fehler beim Abrufen der Team-Storyboards',
  teamGetUsersError: 'Fehler beim Ermitteln der Benutzer des Teams',
  teamName: 'Teamname',
  teamNamePlaceholder: 'Teamnamen eingeben',
  teams: 'Teams',
  teamSave: 'Team speichern',
  teamUserRequiredToCheckin: 'Benutzer muss im Team sein, um einzuchecken',
  teamUserRequiredToComment: 'Benutzer muss im Team sein, um zu kommentieren',
  today: 'Heute',
  todayPlaceholder: 'Heute werde ich...',
  totalPoints: 'Gesamtpunkte',
  totalVotes: 'Gesamtabstimmungen',
  type: 'Typ',
  unknownWarrior: 'Unbekannter Benutzer',
  unpointed: 'Nicht geschätzt ({count})',
  updateActionItemError: 'Fehler beim Aktualisieren des Action Items',
  updateActionItemSuccess: 'Action Item erfolgreich aktualisiert',
  updateAlertError: 'Fehler beim Aktualisieren des Alarms',
  updateAlertSuccess: 'Alarm erfolgreich aktualisiert',
  updateCheckinError: 'Fehler beim Aktualisieren des Check-ins',
  updateComment: 'Kommentar aktualisieren',
  userAdd: 'Benutzer hinzufügen',
  userAddError: 'Fehler beim Versuch, den Benutzer hinzuzufügen',
  userAddSuccess: 'Benutzer erfolgreich hinzugefügt',
  userEmail: 'Benutzer E-Mail',
  userEmailPlaceholder: 'Enter the users email',
  userName: 'Benutzername',
  userRemoveError: 'Fehler beim Versuch, den Benutzer zu entfernen',
  userRemoveSuccess: 'Benutzer erfolgreich entfernt',
  users: 'Benutzer',
  verifyAccount: 'Konto verifizieren',
  verifyAccountFailedError:
    'Bei der Überprüfung des Kontos ist ein Fehler aufgetreten. Möglicherweise ist dieser Link abgelaufen oder wurde bereits verwendet.',
  verifyAccountFailedTitle: 'Überprüfung fehlgeschlagen',
  verifyAccountLoading: 'Kontoüberprüfung...',
  verifyAccountVerifiedThanks: 'Vielen Dank für die Bestätigung der E-Mail-Adresse.',
  verifyAccountVerifiedTitle: 'Konto überprüft',
  view: 'Anzeigen',
  vote: 'Abstimmen',
  voteCount: 'Stimmenanzahl',
  votePhaseDescription: 'Stimmen Sie für die Gruppen, über die Sie am liebsten diskutieren würden',
  voteResultsAverage: 'Durchschnitt',
  voteResultsHighest: 'Höchster',
  votingFinish: 'Schätzung beenden',
  votingLocked: 'Abstimmung gesperrt',
  votingRestart: 'Schätzung neu starten',
  warriorCreate: 'Benutzer erstellen',
  warriorInvite: 'Benutzer einladen',
  warriorNudge: 'Anstubsen',
  works: 'Funktioniert',
  writeCommentPlaceholder: 'Einen Kommentar schreiben...',
  yesterday: 'Gestern',
  yesterdayPlaceholder: 'Gestern habe ich...',
  yourRetros: 'Ihre Retros',
  yourStoryboards: 'Ihre Storyboards',
  addPlan: 'Story hinzufügen',
  battleNamePlaceholder: 'Geben Sie den Namen der Partie ein',
  autoFinishVotingLabel: 'Schätzung automatisch beenden, wenn alle Benutzer abgestimmt haben',
  averageRoundingOptions: {
    ceil: 'Aufrunden',
    floor: 'Abrunden',
    round: 'Kaufm. runden',
  },
  apiKeyCreateButton: 'API-Schlüssel erstellen',
  apiKeyPrefix: 'Schlüsselpräfix',
  lastUpdated: 'Zuletzt aktualisiert',
  apiKeysErrorRetrieving: 'Fehler beim Abrufen der API-Schlüssel',
  apiKeyDeleteSuccess: 'API-Schlüssel gelöscht',
  apiKeyDeleteFailed: 'Fehler beim Löschen des API-Schlüssels',
  apiKeyUpdateSuccess: 'API-Schlüssel aktualisiert',
  apiKeyUpdateFailed: 'Fehler beim Aktualisieren des API-Schlüssels',
  deactivate: 'Deaktivieren',
  profileErrorRetrieving: 'Fehler beim Abrufen des Profils',
  profileErrorUpdating: 'Fehler beim Aktualisieren des Profils',
  profileUpdateSuccess: 'Profil erfolgreich aktualisiert',
  passwordUpdated: 'Passwort aktualisiert',
  passwordUpdateError: 'Fehler beim Aktualisieren des Passworts',
  profileDeleteError: 'Fehler beim Löschen des Profils',
  profileTitle: 'Profil',
  profile: 'Profil',
  updatePassword: 'Passwort \u00E4ndern',
  deleteAccount: 'Konto l\u00F6schen',
  deleteAccountWarningStatement: 'Konto wirklich l\u00F6schen? Dies kann nicht R\u00FCckg\u00E4ngig gemacht werden.',
  deleteConfirmButton: 'L\u00F6schen best\u00E4tigen',
  apiKeyNameInvalid: 'Bitte einen Key Namen angeben',
  apiKeyCreateSuccess:
    'Neuer Api Key {keyName} erstellt und {onlyNowOpen}dieser wird nur jetzt angezeigt{onlyNowClose}',
  apiKeyStoreWarning:
    'Bitte den Api Key an einem sicheren Ort aufbewahren, da dieses generierte Token nicht mehr abgerufen oder wiederhergestellt werden kann, sobald diese Seite verlassen wurde.',
  apiKeyLimitReached: 'Sie haben die maximale Anzahl an API-Schlüsseln erreicht.',
  apiKeyUnverifiedUser: 'Nur verifizierte registrierte Benutzer können API-Schlüssel erstellen.',
  apiKeyCreateFailed: 'API Key konnte nicht erstellt werden',
  apiKeyName: 'Key Name',
  apiKeyNamePlaceholder: 'Key Name eingeben',
  create: 'Erstellen',
  close: 'Schlie\u00dfen',
  country: 'Land',
  company: 'Unternehmen',
  verified: 'Best\u00E4tigt',
  registeredUsers: 'Registrierte Benutzer',
  myBattles: 'Meine Partien',
  createBattle: 'Partie erstellen',
  countPlansPointed: '{totalPointed} von {totalPlans} Stories geschätzt',
  myBattlesError: 'Fehler: Keine Partie gefunden',
  warriorJoined: '{name} hat die Partie betreten',
  warriorRetreated: '{name} hat die Partie verlassen',
  planSkipped: 'Story übersprungen',
  warriorVoted: '{name} hat eine Sch\u00E4tzung abegeben',
  warriorRetractedVote: '{name} hat die Sch\u00E4tzung zur\u00FCckgezogen',
  battleDeleted: 'Partie gel\u00F6scht',
  warriorNudgeMessage: 'pst... {name}, wir warten auf eine Sch\u00E4tzung',
  battle: 'Partie',
  warriors: 'Benutzer',
  battleSocketReconnecting: 'Ooops Partien werden neu geladen...',
  battleSocketError: 'Fehler beim Eintritt in die Partie, bitte aktualisieren und nochmals versuchen.',
  battleLoading: 'Lade Partien...',
  votingNotStarted: 'Sch\u00E4tzung noch nicht gestartet',
  password: 'Passwort',
  passwordPlaceholder: 'Geben Sie ein Passwort ein',
  yourPasswordPlaceholder: 'Geben Sie Ihr Passwort ein',
  confirmPassword: 'Passwort bestätigen',
  confirmPasswordPlaceholder: 'Bestätigen Sie Ihr Passwort',
  update: 'Aktualisieren',
  reset: 'Zurücksetzen',
  passwordResetError: 'Fehler beim Versuch, das Passwort zurückzusetzen',
  resetPassword: 'Passwort zurücksetzen',
  registerAsGuest: 'Als Gast registrieren',
  registrationDisabled: 'Die Registrierung ist deaktiviert.',
  userNamePlaceholder: 'Geben Sie Ihren Namen ein',
  guestRegisterError: 'Fehler beim Versuch, sich als Gast zu registrieren',
  registerError: 'Fehler beim Versuch, das Konto zu registrieren',
  enlistToBattle: 'Zur Schlacht anmelden',
  loginForBattle: 'oder {loginOpen}Anmelden{loginClose} um der Partie beizutreten',
  yourNamePlaceholder: 'Geben Sie Ihren Namen ein',
  createAccountFormTitle: 'Konto erstellen {optionalOpen}(optional){optionalClose}',
  sendResetPasswordSuccess: 'Anweisungen zum Zurücksetzen des Passworts wurden an {email} gesendet',
  sendResetPasswordError: 'Fehler beim Versuch, das Passwort zurückzusetzen zu senden',
  chooseCountryPlaceholder: 'Wählen Sie Ihr Land aus (optional)',
  locale: 'Sprache',
  companyPlaceholder: 'Geben Sie Ihr Unternehmen ein (optional)',
  jobTitle: 'Berufsbezeichnung',
  jobTitlePlaceholder: 'Geben Sie Ihre Berufsbezeichnung ein (optional)',
  enableBattleNotifications: 'Partiemeldungen aktivieren',
  avatar: 'Avatar',
  userInviteSent: 'Benutzereinladung versendet',
  inviteUserFieldNote: 'Eine Einladung zur Teilnahme an der {pageType} wird gesendet werden.',
  updateProfile: 'Profil aktualisieren',
  guestUsers: 'Gastbenutzer',
  maintenance: 'Wartung',
  cleanGuests: 'Gäste löschen, die älter als {daysOld} Tage sind',
  cleanBattles: 'Partien löschen, die älter als {daysOld} Tage sind',
  chooseLocalePlaceholder: 'Wählen Sie Ihre bevorzugte Sprache (optional)',
  importPlans: 'Stories importieren',
  selectFile: 'Datei auswählen...',
  theme: 'Thema',
  assignees: 'Zuweisungen',
  assigneeSelectPlaceholder: 'Wählen Sie eine Zuweisung zum Hinzufügen',
  assigneeAdd: 'Zuweisung hinzufügen',
  allStoryWithCount: 'Alle ({count})',
  userUpdate: 'Benutzer aktualisieren',
  userUpdateSuccess: 'Benutzer erfolgreich aktualisiert.',
  userUpdateError: 'Fehler beim Aktualisieren des Benutzers.',
  userInvites: 'Benutzereinladungen',
  userInviteConfirmDelete: 'Sind Sie sicher, dass Sie diese Benutzereinladung löschen möchten?',
  userInviteDelete: 'Einladung löschen',
  expireDate: 'Ablaufdatum',
  addUserWillInviteNotFoundFieldNote:
    'Wenn der Benutzer nicht registriert ist, wird eine Einladung zur Registrierung und Teilnahme an der {pageType} gesendet.',
  teamUpdateSuccess: 'Team erfolgreich aktualisiert',
  teamUpdateError: 'Fehler beim Aktualisieren des Teams',
  orgUpdateSuccess: 'Organisation erfolgreich aktualisiert',
  orgUpdateError: 'Fehler beim Aktualisieren der Organisation',
  deptUpdateSuccess: 'Abteilung erfolgreich aktualisiert',
  deptUpdateError: 'Fehler beim Aktualisieren der Abteilung',
  hideVoterIdentity: 'Identität des Schätzers verbergen',
  storyboardName: 'Storyboard Name',
  storyboardNamePlaceholder: 'Geben Sie einen Storyboard-Namen ein',
  retroPhaseTimeLimitMinLabel: 'Brainstorm Phase Zeitlimite in Minuten',
  phaseAutoAdvanceLabel: 'Phasen automatisch weiterschalten',
  removeOnlyFacilitatorError: 'Letzter Moderator kann nicht entfernt werden',
  noGamesFound: 'Keine Games gefunden, versuchen Sie eines zu erstellen.',
  noRetrosFound: 'Keine Retros gefunden, versuchen Sie eines zu erstellen.',
  noStoryboardsFound: 'Keine Storyboards gefunden, versuchen Sie eines zu erstellen.',
  retroDescription:
    'Eine Sprint Retrospektive (Retro) ist ein Rückblick nach dem Sprint, welcher in der Agilen Methodik eine wichtige Rolle spielt. Ein Retro hat zum Ziel hervorzubringen was gut lief, wo es Probleme gab, und in welchen Bereichen Verbesserungen möglich sind.',
  pokerDescription:
    'Scrum poker, auch bekannt als "Planning Poker" und "Pointing poker", ist eine gamifizierte Technik, welche Entwicklerteams nutzen um den Aufwand von Aufgaben zu schätzen. Die Schätzungen sind basierend auf den Rückmeldungen der ganzen Gruppe und deren Konsens, was sie genauer und fesselnder macht als vergleichbare Methoden.',
  storyboardDescription:
    'User Story Mapping (Storyboard) ist eine Visualisierung des Ablaufs, die ein Kunde durch das Produkt macht, vom Anfang bis zum Abschluss. Sie enthält alle Schritte, welche die Kunden typischerweise ausführen in diesem Ablauf.',
  estimationScaleNamePlaceholder: 'Skalennamen eingeben',
  description: 'Beschreibung',
  estimationScaleDescriptionPlaceholder: 'Skalenbeschreibung eingeben',
  scaleType: 'Skalentyp',
  estimationScaleTypePlaceholder: 'Skalentyp auswählen',
  scaleValues: 'Skalenwerte',
  estimationScaleValuesPlaceholder: 'Kommagetrennte Werte eingeben',
  estimationScaleValuesHelp: 'Geben Sie Werte durch Kommas getrennt ein (z.B. 1, 2, 3, 5, 8)',
  estimationScaleIsPublic: 'Diese Skala öffentlich machen',
  estimationScaleDefault: 'Als Standardskala festlegen',
  estimationScaleSave: 'Skala speichern',
  estimationScales: 'Estimation Scales',
  estimationScaleCreate: 'Skala erstellen',
  estimationScaleCreateSuccess: 'Skala erfolgreich erstellt',
  estimationScaleCreateError: 'Fehler beim Erstellen der Skala',
  estimationScaleUpdateSuccess: 'Skala erfolgreich geändert',
  estimationScaleUpdateError: 'Fehler beim Ändern der Skala',
  estimationScaleRemoveSuccess: 'Skala erfolgreich gelöscht',
  estimationScaleRemoveError: 'Fehler beim Löschen der Skala',
  removeEstimationScaleConfirmText: 'Wollen Sie diese Skala wirklich löschen?',
  removeEstimationScale: 'Skala löschen',
  yes: 'Ja',
  no: 'Nein',
  isPublic: 'Öffentlich',
  default: 'Standard',
  publicEstimationScales: 'Öffentliche Skalen',
  organizationEstimationScales: 'Organisation Skalen',
  teamEstimationScales: 'Team Skalen',
  allowCumulativeVotingLabel: 'Erlauben von kumulativen Abstimmungen (mehr als 1 Stimme pro Item Gruppe)',
  activeSubscriptions: 'Aktive Subscriptions',
  retroTemplates: 'Retro Vorlagen',
  publicRetroTemplates: 'Öffentliche Retro Vorlagen',
  organizationRetroTemplates: 'Organisation Retro Vorlagen',
  teamRetroTemplates: 'Team Retro Vorlagen',
  retroTemplateNamePlaceholder: 'Vorlagenamen eingeben',
  retroTemplateDescriptionPlaceholder: 'Vorlagebeschreibung eingeben',
  format: 'Format',
  retroTemplateIsPublic: 'Diese Vorlage öffentlich machen',
  retroTemplateSave: 'Vorlage speichern',
  retroTemplateCreate: 'Retrovorlage erstellen',
  retroTemplateCreateSuccess: 'Retrovorlage erfolgreich erstellt',
  retroTemplateCreateError: 'Fehler beim Erstellen der Retrovorlagen',
  retroTemplateUpdateSuccess: 'Retrovorlage erfolgreich geändert',
  retroTemplateUpdateError: 'Fehler beim Löschen der Retrovorlage',
  retroTemplateRemoveSuccess: 'Retrovorlage erfolgreich gelöscht',
  retroTemplateRemoveError: 'Fehler beim Löschen der Retrovorlage',
  removeRetroTemplateConfirmText: 'Wollen Sie diese Retrovorlage wirklich löschen?',
  removeRetroTemplate: 'Retrovorlage löschen',
  retroTemplateDefault: 'Als Standardvorlage setzten',
  jiradatacenterLabel: 'Jira DataCenter',
  requestEmailChangeSuccess: 'E-Mail-Änderungsanfrage gesendet, überprüfen Sie Ihren Posteingang für Anweisungen',
  requestEmailChangeError: 'Fehler beim Versuch, die E-Mail zu ändern',
  changeEmail: 'E-Mail ändern',
  errorChangingEmail:
    'Fehler beim Versuch, die E-Mail zu ändern, möglicherweise ist dieser Link abgelaufen oder wurde bereits verwendet.',
  emailChanged: 'E-Mail erfolgreich geändert',
  newEmailToLogin: 'Von jetzt an verwenden Sie bitte Ihre neue E-Mail für die Anmeldung.',
  newEmail: 'Neue E-Mail',
  enterYourNewEmail: 'Geben Sie Ihre neue E-Mail ein',
  retroSettings: 'Retro Settings',
  enterFacilitatorCode: 'Enter the Facilitator Code',
  // Modal ariaLabels
  modalCreateAlert: 'Benachrichtigung erstellen',
  modalUpdateEstimationScale: 'Schätzskala aktualisieren',
  modalDeleteConfirmation: 'Löschbestätigung',
  modalCreateEstimationScale: 'Schätzskala erstellen',
  modalTeamCheckin: 'Team Einchecken',
  modalAddPokerStory: 'Poker-Story hinzufügen',
  modalCreateUser: 'Benutzer erstellen',
  modalCreateApiKey: 'API-Schlüssel erstellen',
  modalImportPokerStories: 'Poker-Stories importieren',
  modalSetupMultifactorAuth: 'Multifaktor-Authentifizierung einrichten',
  modalEditPokerGame: 'Poker-Spiel bearbeiten',
  modalCreateJiraInstance: 'Jira-Instanz erstellen',
  modalUpdatePokerSettings: 'Poker-Einstellungen aktualisieren',
  modalAddStoryboardGoal: 'Storyboard-Ziel hinzufügen',
  modalViewPokerStory: 'Poker-Story anzeigen',
  modalStoryboardColumnSettings: 'Storyboard-Spalteneinstellungen',
  modalEditStoryboard: 'Storyboard bearbeiten',
  modalStoryboardColorLegend: 'Storyboard-Farblegende',
  modalStoryboardPersonas: 'Storyboard-Personas',
  modalRetroActionComments: 'Retro-Aktionskommentare',
  modalStoryboardStory: 'Storyboard-Story',
  modalTeamAddUser: 'Team-Benutzer hinzufügen',
  modalCreateDepartment: 'Abteilung erstellen',
  modalCreateTeam: 'Team erstellen',
  modalCreateOrganization: 'Organisation erstellen',
  modalCreateRetroTemplate: 'Retro-Vorlage erstellen',
  modalViewRetroTemplateFormat: 'Retro-Vorlagenformat anzeigen',
  modalUpdateRetroTemplate: 'Retro-Vorlage aktualisieren',
  modalAssociateTeamToSubscription: 'Team mit Abonnement verknüpfen',
  modalAssociateOrganizationToSubscription: 'Organisation mit Abonnement verknüpfen',
  modalTeamUpdateUser: 'Team-Benutzer aktualisieren',
  modalSubscriptionForm: 'Abonnement-Formular',
  modalEditRetro: 'Retro bearbeiten',
  modalEditRetroActionItem: 'Retro-Aktionspunkt bearbeiten',
  modalRetroItemComments: 'Retro-Element-Kommentare',
  modalUpdateRetroSettings: 'Retro-Einstellungen aktualisieren',
  githubRepository: 'GitHub-Repository',
  projects: 'Projekte',
  projectCreate: 'Projekt erstellen',
  projectKey: 'Projekt-Schlüssel',
  scope: 'Bereich',
  createdAt: 'Erstellt am',
  projectRemoveSuccess: 'Projekt erfolgreich entfernt',
  projectRemoveError: 'Fehler beim Entfernen des Projekts',
  removeProjectConfirmText:
    'Sind Sie sicher, dass Sie dieses Projekt entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  removeProject: 'Projekt entfernen',
  modalCreateProject: 'Projekt erstellen',
  modalUpdateProject: 'Projekt aktualisieren',
  projectKeyPlaceholder: 'Projektschlüssel eingeben (z.B. PROJ)',
  projectNamePlaceholder: 'Projektname eingeben',
  projectDescriptionPlaceholder: 'Projektbeschreibung eingeben (optional)',
  projectKeyValidationError: 'Projektschlüssel muss 2-10 alphanumerische Zeichen haben',
  projectKeyHelp: '2-10 Zeichen, nur Buchstaben und Zahlen',
  projectScope: 'Projektumfang',
  projectUpdate: 'Projekt aktualisieren',
  projectCreateSuccess: 'Projekt erfolgreich erstellt',
  projectUpdateSuccess: 'Projekt erfolgreich aktualisiert',
  projectCreateError: 'Projekt konnte nicht erstellt werden',
  projectUpdateError: 'Projekt konnte nicht aktualisiert werden',
  project: 'Projekt',
  gameSettings: 'Spiel Einstellungen',
  endGame: 'Spiel beenden',
  endGameReason: 'Grund für das Beenden des Spiels',
  endGameReasonPlaceholder: 'Wählen Sie einen Grund',
  welcomeBack: 'Willkommen zurück,',
  dashboardSubtitle: 'Lassen Sie uns Ihre nächste Team-Kollaborationssitzung zur besten machen.',
  filterByTeam: 'Nach Team filtern:',
  allTeams: 'Alle Teams',
  showContentForAllTeams: 'Inhalte von allen Teams anzeigen',
  clearFilter: 'Filter löschen',
  teamPage: 'Teamseite',
  dashboardTeamsRequired:
    'Wählen Sie ein Team aus, um Ihre Planning Poker-Sitzungen, Retrospektiven und Storyboards zu sehen.',
  planningPokerSessions: 'Planning Poker-Sitzungen',
  viewAllPokerSessions: 'Alle Planning Poker-Sitzungen anzeigen',
  totalPokerSessions: '{total} Sitzungen insgesamt',
  noSessionsFoundForTeam: 'Keine Sitzungen für {teamName} gefunden',
  noSessionsFound: 'Keine Sitzungen gefunden',
  trySelectingDifferentTeamForPoker: 'Wählen Sie ein anderes Team oder erstellen Sie ein neues Spiel',
  startFirstPlanningPokerSession: 'Starten Sie Ihre erste Planning Poker-Sitzung',
  sprintRetrospectives: 'Sprint-Retrospektiven',
  viewAllRetros: 'Alle Retrospektiven anzeigen',
  totalRetros: '{total} Retrospektiven insgesamt',
  noRetrosFoundForTeam: 'Keine Retrospektiven für {teamName} gefunden',
  startFirstSprintRetrospective: 'Starten Sie Ihre erste Sprint-Retrospektive',
  trySelectingDifferentTeamForRetros: 'Wählen Sie ein anderes Team oder erstellen Sie eine neue Retrospektive',
  viewAllStoryboards: 'Alle Storyboards anzeigen',
  totalStoryboards: '{total} Storyboards insgesamt',
  noStoryboardsFoundForTeam: 'Keine Storyboards für {teamName} gefunden',
  startFirstStoryboard: 'Starten Sie Ihr erstes Storyboard',
  agileStoryMapping: 'Agiles Story Mapping',
  trySelectingDifferentTeamForStoryboards: 'Wählen Sie ein anderes Team oder erstellen Sie ein neues Storyboard',
  supportTickets: 'Support-Tickets',
  supportTicketDeleteConfirmation:
    'Sind Sie sicher, dass Sie dieses Support-Ticket löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  supportTicketDelete: 'Ticket löschen',
  updateSupportTicketSuccess: 'Support-Ticket erfolgreich aktualisiert',
  updateSupportTicketError: 'Fehler beim Aktualisieren des Support-Tickets',
  getSupportTicketsError: 'Fehler beim Abrufen der Support-Tickets',
  deleteSupportTicketSuccess: 'Support-Ticket erfolgreich gelöscht',
  requiresOrganizationMember: 'Diese Aktion erfordert, dass Sie Mitglied der Organisation sind',
  deleteSupportTicketError: 'Fehler beim Löschen des Support-Tickets',
  clear: 'Löschen',
};

export default de;
